/**
 * Clés des contraintes de salle de bain
 * Ces clés correspondent aux contraintes stockées en base de données pour celles qui sont communes
 */
export class CommonConstraintKeys {
  /**
   * Largeur minimale de la première rangée (en cm)
   */
  static readonly MIN_FIRST_ROW_WIDTH = 'MIN_FIRST_ROW_WIDTH';

  /**
   * Longueur maximale du décalage (en mètres)
   */
  static readonly MAX_OFFSET_LENGTH = 'MAX_OFFSET_LENGTH';
}

export class KentiaConstraintKeys {
  /**
   * Largeur maximale pour vasque à poser (en cm)
   */
  static readonly MAX_TOILET_TOP_WIDTH = 'MAX_TOILET_TOP_WIDTH';

  /**
   * Largeur maximale du plan vasque (en cm)
   */
  static readonly MAX_BASIN_PLAN_WIDTH = 'MAX_BASIN_PLAN_WIDTH';

  /**
   * Largeur pour double vasque (en cm)
   */
  static readonly DOUBLE_BASIN_WIDTH = 'DOUBLE_BASIN_WIDTH';

  /**
   * Largeur d'exception pour la pose d'un plan vasque (en cm)
   */
  static readonly EXCEPTION_BASIN_PLAN_WIDTH = 'EXCEPTION_BASIN_PLAN_WIDTH';
}

/**
 * Valeurs par défaut des contraintes (fallback si non trouvées en BDD)
 */
export class BathroomConstraintDefaults {
  // Contraintes globales
  static readonly MIN_FIRST_ROW_WIDTH = 60;
  static readonly MAX_OFFSET_LENGTH = 0.5;

  // Contraintes spécifiques
  static readonly MAX_TOILET_TOP_WIDTH = 140;
  static readonly MAX_BASIN_PLAN_WIDTH = 120;
  static readonly DOUBLE_BASIN_WIDTH = 100;
  static readonly EXCEPTION_BASIN_PLAN_WIDTH = 100;
}
